import { BasicCommand } from "../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../common/services/cqs/CommandType";
export class SetEjEudrCommand extends BasicCommand<SetEjEudrCommand> {
    get primaryKey() {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    ejEudr?: boolean;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetEjEudrCommand";
    constructor(init: (instance: SetEjEudrCommand) => void) {
        super(SetEjEudrCommand.$type, "Arbetsorder", CommandType.Replace);
        init(this);
    }
}
